import type { Country } from '@backmarket/http-api'

import { STATES } from '../../constants/states'
import type { State } from '../../types/state'

export function getAllStates(country: Country): State[] {
  return STATES[country] || []
}
